// React
import React, { useEffect, useState } from "react";
// React
// CSS
import styles from "./Step1.module.css";
// CSS
// Services
import { login_Service } from "../../../Services/Login/get/login_Service";
// Services
// Modules
import { toast } from "react-toastify";
// Modules
// Utils
import Spinner from "../../../Utils/Spinner/Spinner";
// Utils
// Images
import { logo_1 } from "../../../Images/images";
import { getBeginPageImageService } from "../../../Services/Common/getBeginPageImageService";
// Images

type Step1Props = {
  setUserPhoneNumber: React.Dispatch<React.SetStateAction<number | string>>;
  userPhoneNumber: number;
  setFormStep: React.Dispatch<React.SetStateAction<1 | 2 | 3>>;
  isPending: boolean;
  setIsPending: React.Dispatch<React.SetStateAction<boolean>>;
  isRegisterNeed: boolean;
  setIsRegisterNeed: React.Dispatch<React.SetStateAction<boolean>>;
};

const Step1: React.FunctionComponent<Step1Props> = ({
  setUserPhoneNumber,
  userPhoneNumber,
  setFormStep,
  isPending,
  isRegisterNeed,
  setIsPending,
  setIsRegisterNeed,
}) => {
  const [beginPageData, setBeginPageData] = useState<{
    url: string;
    link: string;
  }>({
    url: "",
    link: "",
  });

  useEffect(() => {
    getBeginPageImageService()
      .then(({ data: { url, link } }) => {
        setBeginPageData({ url, link });
      })
      .catch((err: any) => {
        console.log(err);
        toast(
          err.response.data.message ? err.response.data.message : err.message,
          {
            icon: "error",
          }
        );
      });
  }, []);

  return (
    <>
      <div
        className={`${styles.step1Container} flex flex-col items-center justify-start p-5 py-8 bg-white rounded-xl relative`}
      >
        <img src={logo_1} alt="" className={`${styles.image}`} />
        <a href={beginPageData.link} target="_blank" rel="noreferrer">
          <img src={beginPageData.url} alt="" className="my-2" />
        </a>
        {/* <InputMask
          mask="9999_999_99_99"
          className={`rounded-2xl my-4 py-3 placeholder:font-bold w-full`}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            function convertToEnglishNumbers(str: string) {
              const persianDigits = [
                /۰/g,
                /۱/g,
                /۲/g,
                /۳/g,
                /۴/g,
                /۵/g,
                /۶/g,
                /۷/g,
                /۸/g,
                /۹/g,
              ];
              const englishDigits = [
                /0/g,
                /1/g,
                /2/g,
                /3/g,
                /4/g,
                /5/g,
                /6/g,
                /7/g,
                /8/g,
                /9/g,
              ];

              for (let i: any = 0; i < 10; i++) {
                str = str
                  .replace(persianDigits[i], i)
                  .replace(englishDigits[i], i);
              }

              return str;
            }

            const eventTargetValue = convertToEnglishNumbers(e.target.value);

            if (Number(eventTargetValue).toString().startsWith("0")) {
              setUserPhoneNumber(() => {
                return eventTargetValue
                  .slice(0, 1)
                  .split(" ")
                  .filter((item) => item !== "_")
                  .join("");
              });
              return;
            } else {
              setUserPhoneNumber(() => {
                return eventTargetValue
                  .split("_")
                  .filter((item) => item !== "_")
                  .join("");
              });
            }
          }}
          placeholder="0912 123 12 12"
          type="text"
        /> */}
        <input
          type="number"
          placeholder="شماره تلفن موبایل به لاتین"
          className={`rounded-2xl my-4 py-3 placeholder:font-bold w-full  dark:!text-black placeholder:!text-sm`}
          value={userPhoneNumber}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            // function convertToEnglishNumbers(str: string) {
            //   const persianDigits = [
            //     /۰/g,
            //     /۱/g,
            //     /۲/g,
            //     /۳/g,
            //     /۴/g,
            //     /۵/g,
            //     /۶/g,
            //     /۷/g,
            //     /۸/g,
            //     /۹/g,
            //   ];
            //   const englishDigits = [
            //     /0/g,
            //     /1/g,
            //     /2/g,
            //     /3/g,
            //     /4/g,
            //     /5/g,
            //     /6/g,
            //     /7/g,
            //     /8/g,
            //     /9/g,
            //   ];
            //   for (let i: any = 0; i < 10; i++) {
            //     str = str
            //       .replace(persianDigits[i], i)
            //       .replace(englishDigits[i], i);
            //   }
            //   return str;
            // }

            // const eventTargetValue = convertToEnglishNumbers(e.target.value);

            // if (Number(eventTargetValue).toString().startsWith("0")) {
            //   setUserPhoneNumber(() => {
            //     return eventTargetValue
            //       .slice(0, 1)
            //       .split(" ")
            //       .filter((item) => item !== "_")
            //       .join("");
            //   });
            //   return;
            // } else {
            //   setUserPhoneNumber(() => {
            //     return eventTargetValue
            //       .split("_")
            //       .filter((item) => item !== "_")
            //       .join("");
            //   });
            // }

            setUserPhoneNumber(e.target.valueAsNumber);
          }}
        />
        <button
          className={`${styles.submitBtn} w-full rounded-2xl py-3 text-white flex items-center justify-center`}
          onClick={() => {
            if (isPending) return;
            if (!userPhoneNumber) return;
            if (
              (userPhoneNumber.toString().length === 10 &&
                userPhoneNumber.toString().startsWith("9")) ||
              (userPhoneNumber.toString().length === 11 &&
                userPhoneNumber.toString().startsWith("0"))
            ) {
              setIsPending(true);
              login_Service(userPhoneNumber)
                .then(({ data, status }) => {
                  // console.log(data);
                  if (status === 200 || 201) {
                    // console.log(data);
                    toast("کد ارسال شد");

                    if (Number(data.is_register) === 1) {
                      setIsRegisterNeed(true);
                      setFormStep(2);
                      return;
                    } else if (Number(data.is_register) === 0) {
                      setIsRegisterNeed(false);
                      setFormStep(2);
                      return;
                    } else {
                    }
                  }
                })
                .catch((err) => {
                  console.log("err", err);
                  toast(
                    err.response.data.message
                      ? err.response.data.message
                      : err.message
                  );
                  setIsPending(false);
                });
              return;
            }
            toast("لطفا شماره موبایل را به شکل صحیح وارد کنید");
            return;
          }}
        >
          {isPending ? (
            <>
              <Spinner />
            </>
          ) : (
            <>ورود</>
          )}
        </button>
      </div>
    </>
  );
};

export default Step1;
